export function countEqualCharacters(str1: string, str2: string): number {
    let count = 0;
    const minLength = Math.min(str1.length, str2.length);
    
    for (let i = 0; i < minLength; i++) {
        if (str1[i].toLowerCase() === str2[i].toLowerCase()) {
            count++;
        } else {
            break; // Stop counting when characters don't match
        }
    }
    
    return count;
}